import { Action } from "../../../actions/actions";
import { AuthActionTypes } from "../actions/actionTypes";

const initialState: boolean = false;

export function submittingSignupReducer(state = initialState, action: Action) {
    switch (action.type) {
        case AuthActionTypes.SIGNUP:
            return !state;
        case AuthActionTypes.SIGNUP_SUCCESS:
        case AuthActionTypes.SIGNUP_FAIL:
            return !state;
        default:
            return state;
    }
}
